import styled from "styled-components/macro";
import { backgroundColor } from "theme";

import FnrButton from "UI/FnrButton3/FnrButton";
import FnrFade from "UI/FnrFade";
import { InputWrapper } from "UI/FnrInput/";

import DayPicker from "./DayPicker";
import { useFnrDateInput2 } from "./FnrDatePicker2Context";
import MonthPicker from "./MonthPicker";
import YearInput from "./YearInput";

const SFnrButton = styled(FnrButton)`
  height: 28px;
  margin-right: 8px;
`;

// essentially a copy of FnrDateInput with 2 main differences
// 1. it doesn't use the FnrToggle component meaning it doesn't include floating hover styles of the buttons
// 2. it uses FnrCombobox instead of manually adding the buttons and popovers
// 2.1. this allows us to easily include keyboard navigation and filtering of the options
export default function DateInput({
  placeholder,
  style,
  focusColor,
  killHoverStyles,
  includeYear = true,
  clearDateId,
  preventDefault,
  noWrap,
  className,
  showSave,
  onSave,
  isLoading,
  backgroundColor,
}) {
  const { setState } = useFnrDateInput2();

  const handleClearDate = (e) => {
    e.preventDefault();
    // clearDateId is passed in from the parent component so that it can programmatically click the hidden button to clear the date
    if (clearDateId) {
      setState({ month: "", day: "", year: "" });
    }
  };

  return (
    <Wrapper
      $backgroundColor={backgroundColor}
      className={className}
      style={style}
    >
      <Title>{placeholder}</Title>

      <Fields data-cy="fnrDateField" $noWrap={noWrap}>
        <MonthPicker
          disabled={isLoading}
          focusColor={focusColor}
          preventDefault={preventDefault}
        />
        <DayPicker disabled={isLoading} focusColor={focusColor} />
        {includeYear && (
          <YearInput disabled={isLoading} focusColor={focusColor} />
        )}
        <FnrFade show={showSave && Boolean(onSave)} top={false} left>
          <SFnrButton
            loading={isLoading}
            color="green"
            size="small"
            onClick={onSave}
          >
            Save
          </SFnrButton>
        </FnrFade>
      </Fields>
      <ClearDateButton
        data-clear-date={clearDateId}
        onClick={handleClearDate}
      />
    </Wrapper>
  );
}
const Wrapper = styled(InputWrapper)`
  padding: 2px;
  color: #333;
  user-select: none;
  overflow: hidden;
  width: auto;
  background: none;
  border: none;
  ${backgroundColor}

  &.household-date-input {
    border: 1px solid;
    border-color: #e0e0e0;
    border-radius: 10px;
    font-size: 18px;
    font-weight: 400;
    transition: border 0.3s;

    &:focus-within {
      border-color: transparent;
    }
  }
`;

const Title = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  color: #828c8d;
  font-weight: 400;
  line-height: 15px;
  padding: 2px 5px;
  padding-bottom: 0;
  z-index: 100;
`;

const Fields = styled.div`
  display: flex;
  flex-wrap: ${({ $noWrap }) => ($noWrap ? "nowrap" : "wrap")};
  color: #475b68;
  z-index: 100;
  position: relative;
  align-items: center;
`;

const ClearDateButton = styled.button`
  visibility: hidden;
  position: absolute;
  height: 0;
  width: 0;
  border: none;
  padding: 0;
  margin: 0;
`;
